import Cookies from "js-cookie";

export default function () {
  $(".signup__input").focus(function () {
    $(this).parent().addClass("active");
  });

  $(".signup__input").blur(function () {
    $(this).parent().removeClass("active");
  });

  $("#gmp_firstname").on("blur", function () {
    let firstName = $(this).val();
    if (firstName.length < 1) {
      $(this).addClass("error");
    }
    Cookies.set("GMP_first_name", firstName);
  });

  $("#gmp_lastname").on("blur", function () {
    let lastName = $(this).val();
    if (lastName.length < 1) {
      $(this).addClass("error");
    }
    Cookies.set("GMP_last_name", lastName);
  });

  var $loginLink = $("#signup-login");
  var $signupContainer = $(".signup__container");

  $signupContainer
    .css("display", "flex")
    .show()
    .addClass("animated fadeIn fast")
    .on("animationend", function () {
      $signupContainer.removeClass("animated fadeIn fast");
    });

  $loginLink.on("click", function (event) {
    event.preventDefault();
    var $linkLocation = this.href;
    $signupContainer.addClass("fadeOut").on("animationend", function () {
      window.location = $linkLocation;
    });
  });
}



// WEBPACK FOOTER //
// ./scripts/components/SetupSignup.js